import React from 'react';

export const DonateZelle = () => (
  <div className="donation-info">
    <p className="site-eyebrow">Other ways to give</p><h2>Donate directly</h2>
    <p>Every contribution supports the construction, operation, and long-term maintenance of Garden of Peace.</p>
    <div className="donation-option"><span><i className="fas fa-mobile-alt" aria-hidden="true" /></span><div><h3>PayPal or Zelle</h3><p>Send your donation to <a href="mailto:gardenofpeace.usa@gmail.com">gardenofpeace.usa@gmail.com</a>. Please include your email in the comments so we can contact you if needed.</p></div></div>
    <div className="donation-option"><span><i className="fas fa-envelope" aria-hidden="true" /></span><div><h3>Donate by check</h3><p>Mail your check to P.O. Box 3216, Santa Clara, CA 95055.</p></div></div>
    <p className="donation-info__note">Any amount, no matter how small, is deeply appreciated. Thank you for supporting this lasting community resource.</p>
  </div>
);
